export const ALLOWED_EXTENSIONS = [
	'.doc',
	'.docx',
	'.rtf',
	'.xls',
	'.xlsx',
	'.pdf',
	'.txt',
	'.xml',
	'.png',
	'.jpeg',
	'.jpg',
	'.tif',
	'.mov',
	'.bmp',
	'.odt',
	'.eztxml',
	'.srt',
	'.stl',
	'.psd',
	'.aif',
	'.dfxp',
	'.ezt',
	'.pem',
	'.ttml'
]

export const VALID_DESTINATION_PATHS = [
	{
		path: '/media/DATA/1305j552_travaux/_INBOX',
		re: /^\/media\/data\/1305j552_travaux\/_inbox.*$/
	},
	{
		path: '/media/DATA/0709f098_temp/[Tous les sous dossiers]',
		re: /^\/media\/data\/0709f098_temp\/.+$/
	}
]

export const isUploaderEnabled = (currentPath, currentError) => {
	if (!currentPath) return false
	if (currentError) return false
	let enabled = false
	if (window.appConfig._$ppt9qr === 'development') {
		enabled = true
	} else {
		for (const validePath of VALID_DESTINATION_PATHS) {
			if (currentPath.toLowerCase().match(validePath.re)) {
				enabled = true
				break
			}
		}
	}
	return enabled
}

export const MAX_FILE_SIZE = 10240



// WEBPACK FOOTER //
// ./src/pages/filesystem/explorer_uploader.js